function cov_1c197j2dhs() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Email.tsx";
  var hash = "39f8aa3133314280f61b435e080bba8d4b08a46e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Email.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "39f8aa3133314280f61b435e080bba8d4b08a46e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1c197j2dhs = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1c197j2dhs();
var Icon = (cov_1c197j2dhs().s[0]++, {
  name: 'email',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22 21V9.52066C22 9.19434 21.8408 8.88855 21.5735 8.70143L12.5735 2.40143C12.2291 2.1604 11.7709 2.1604 11.4265 2.40143L2.42654 8.70143C2.15921 8.88855 2 9.19434 2 9.52066V21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21ZM18.3436 9.49214L12 5.05164L5.65643 9.49214L12 13.97L18.3436 9.49214ZM4.5 11.7359V19.5H19.5V11.7359L13.2975 16.1141C12.5196 16.6632 11.4803 16.6632 10.7025 16.1141L4.5 11.7359Z\" fill=\"currentColor\"/>"
});
export default Icon;